<template>
  <div>
    <Breadcrumb :breadcrumb="breadcrumb"></Breadcrumb>
    <h5 class="title is-5 has-text-danger">{{ $t("projects.delete") }}</h5>
    <AlertMessage
      color="is-danger"
      :message="$t('projects.deleteMessage')"
    ></AlertMessage>
    <table class="table is-fullwidth is-striped">
      <thead></thead>
      <tbody>
        <tr>
          <th width="25%">{{ $t("projects.projectId") }}</th>
          <td>{{ project.projectId }}</td>
        </tr>
        <tr>
          <th>{{ $t("projects.projectName") }}</th>
          <td>{{ project.projectName }}</td>
        </tr>
        <tr>
          <th>{{ $t("projects.projectOwner") }}</th>
          <td>{{ project.projectOwner }}</td>
        </tr>
        <tr>
          <th>{{ $t("Created_at") }}</th>
          <td>{{ project.created_at }}</td>
        </tr>
        <tr>
          <th>{{ $t("Updated_at") }}</th>
          <td>{{ project.updated_at }}</td>
        </tr>
      </tbody>
    </table>
    <button class="button is-danger" @click="showModal">
      {{ $t("projects.delete") }}
    </button>
    <Modal
      :imageModalView="modalView"
      :modalTitle="$t('projects.delete')"
      :modalAction="$t('Delete')"
      @close="closeModal"
      @doAction="deleteProject()"
    >
      <h6 class="title is-6">{{ project.projectName }}</h6>
      <p class="notification is-danger">
        {{ $t("projects.deleteMessage") }}<br />
        {{ $t("projects.deleteMessageConfirm") }}
      </p>
    </Modal>
  </div>
</template>
<script>
import imsr from "@/imsr-api";
import imsrc from "@/imsr-common";
import { ref } from "@vue/reactivity";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import Breadcrumb from "@/components/Breadcrumb";
import AlertMessage from "@/components/AlertMessage.vue";
import Modal from "@/components/Modal.vue";

export default {
  components: {
    Breadcrumb,
    AlertMessage,
    Modal,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const modalView = ref(false);
    const breadcrumb = [
      {
        title: "Home",
        path: {
          name: "dashboard",
          params: { projectId: store.getters.projectId },
        },
      },
      {
        title: "Project",
        path: {
          name: "projectsView",
          params: { projectId: store.getters.projectId },
        },
      },
      { title: "Delete", path: "#", isActive: true },
    ];
    const project = ref({});

    const getProject = async () => {
      try {
        const params = {
          projectId: route.params.projectId,
          tenantId: store.getters.tenantId,
        };
        project.value = await imsr.imsrGetApi("/projects", params);
        project.value.created_at = imsrc.dateFormat(project.value.created_at);
        project.value.updated_at = imsrc.dateFormat(project.value.updated_at);
      } catch (e) {
        router.push({ name: "InternalServerError" });
      }
    };
    getProject();

    const showModal = () => {
      modalView.value = true;
    };

    const closeModal = () => {
      modalView.value = false;
    };

    const deleteProject = async () => {
      try {
        const params = {
          projectId: route.params.projectId,
          tenantId: store.getters.tenantId,
        };
        await imsr.imsrDeleteApi("/projects", params);
        await store.commit("setProjectId", null);
        await store.commit("setProjectName", null);
        await store.commit("setProjectRole", null);
        modalView.value = false;
        router.push({ name: "projectsList", replace: true });
      } catch (e) {
        router.push({ name: "InternalServerError" });
      }
    };

    return {
      project,
      breadcrumb,
      modalView,
      showModal,
      closeModal,
      deleteProject,
    };
  },
};
</script>
